<template>
  <section class="section">
    <div class="section__content --centered">
      <HeadingBlock :content="content" centered />
      <div class="icon-card__group">
        <IconCard
          :content="card"
          v-for="(card, cardKey) in content.cards"
          :key="cardKey"
          v-reveal="{ delay: 50 * cardKey + 250 }"
        />
      </div>
      <LangRouterLink
        :to="{ name: 'about' }"
        class="button --top --centered"
        v-if="content.label"
        :title="content.label"
        v-reveal="{ delay: 250 }"
      >
        {{ content.label }}
      </LangRouterLink>
      <CTABlock v-if="content.cta.length" :content="content.cta[0]" />
    </div>
  </section>
</template>

<script>
import { CTABlock, HeadingBlock } from '@/components/blocks'
import { IconCard } from '@/components/cards'
import { LangRouterLink } from '@/components/global'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'IconCardsSection',
  mixins: [DefaultSectionProps],
  components: { CTABlock, HeadingBlock, IconCard, LangRouterLink },
}
</script>
